"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTransactionsApiUrl = exports.getTransactionsApiUrl = void 0;
let TRANSACTIONS_API_URL = 'https://transactions-api.decentraland.org/v1';
const getTransactionsApiUrl = () => TRANSACTIONS_API_URL;
exports.getTransactionsApiUrl = getTransactionsApiUrl;
const setTransactionsApiUrl = (url) => (TRANSACTIONS_API_URL = url);
exports.setTransactionsApiUrl = setTransactionsApiUrl;
//# sourceMappingURL=urls.js.map